import { useEffect, useState } from "react"
import { Button } from "../Button"
import GlobalSpinner from "../globalsSpinner/GlobalSpinner";
import { CenterModal, RightModal, SmallModal } from "../sideModal/Modal";
import { FormInput, FormInputNumber, FormRow, FormRowWithColumns } from "../formRow/FormRow";
import { MediaTranscodingProfile, MediaTranscodingProfileRequest, createTranscodingProfile, deleteTranscodingProfile, getTranscodingProfiles, updateTranscodingProfile} from "../../../api/mediaTranscodingApi";
import IconButton from "../iconButton/IconButton";
import { Guid } from "../../../api/baseApi";
import FormCheckbox from "../formRow/FormCheckbox";
import ReactSelect, { MyCustomSelectOptions } from "../customSelect/MyCustomSelect";

type ModalAction = "create" | "edit" | "nothing";
type NumberOrNull = number | null;
type StringOrNull = string | null;

const MediaTranscoding = () => {

    let videoCodecOptions: MyCustomSelectOptions<StringOrNull>[] = [
        {
            label: "h264",
            value: "h264",
        },
        {
            label: "h265",
            value: "h265",
        },
    ]

    let audioCodecOptions: MyCustomSelectOptions<StringOrNull>[] = [
        {
            label:"aac_lc",
            value:"aac_lc"
        },
        {
            label:"heaac_v1",
            value:"heaac_v1"
        },
        {
            label:"heaac_v2",
            value:"heaac_v2"
        },
    ]

    let levelOptions: MyCustomSelectOptions<StringOrNull>[] = [
        {
            label:"low",
            value:"low"
        },
        {
            label:"medium",
            value:"medium"
        },
        {
            label:"high",
            value:"high"
        },
        {
            label:"max",
            value:"max"
        },
    ]

    let videoFrameRateOptions: MyCustomSelectOptions<NumberOrNull>[] = [
        {
            label: "Source",
            value: null
        },
        {
            label: "23.976",
            value: 23.976
        },
        {
            label: "24",
            value: 24
        },
        {
            label: "25",
            value: 25
        },
        {
            label: "29.97",
            value: 29.97
        },
        {
            label: "30",
            value: 30
        },
        {
            label: "48",
            value: 48
        },
        {
            label: "50",
            value: 50
        },
        {
            label: "59.94",
            value: 59.94
        },
        {
            label: "60",
            value: 60
        },
        {
            label: "120",
            value: 120
        },
    ]

    let videoWidthOptions: MyCustomSelectOptions<NumberOrNull>[] = [
        {
            label:"Source",
            value:null
        },
        {
            label:"320",
            value:320
        },
        {
            label:"640",
            value:640
        },
        {
            label:"720",
            value:720
        },
        {
            label:"1280",
            value:1280
        },
        {
            label:"1920",
            value:1920
        },        
        {
            label:"2560",
            value:2560
        },
        {
            label:"3840",
            value:3840
        },
        {
            label:"4096",
            value:4096
        },
    ]

    let audioSmapleOptions: MyCustomSelectOptions<NumberOrNull>[] = [
        {
            label:"Source",
            value:null
        },
        {
            label:"44100",
            value:44100
        },
        {
            label:"48000",
            value:48000
        },
    ]

    let videoBitrateOptions: MyCustomSelectOptions<NumberOrNull>[] = [
        {
            label:"Source",
            value:null
        },
        {
            label:"250",
            value:250
        },
        {
            label:"1000",
            value:1000
        },
        {
            label:"2500",
            value:2500
        },
        {
            label:"5000",
            value:5000
        },
        {
            label:"7500",
            value:7500
        },
        {
            label:"10000",
            value:10000
        },
        {
            label:"25000",
            value:25000
        },
        {
            label:"50000",
            value:50000
        },
    ]

    let audioChannelsOptions: MyCustomSelectOptions<NumberOrNull>[] = [
        {
            label:"Source",
            value:null
        },
        {
            label:"1",
            value:1
        },
        {
            label:"2",
            value:2
        },
        {
            label:"6",
            value:6
        },
    ]

    let audioBitrateOptions: MyCustomSelectOptions<NumberOrNull>[] = [
        {
            label:"Source",
            value:null
        },
        {
            label:"32",
            value:32
        },
        {
            label:"64",
            value:64
        },
        {
            label:"128",
            value:128
        },
        {
            label:"192",
            value:192
        },
        {
            label:"256",
            value:256
        },
        {
            label:"320",
            value:320
        },
    ]

    let [isLoading, setIsLoading] = useState(false);
    let [profiles, setProfiles] = useState<MediaTranscodingProfile[]>([]);
    let [name, setName] = useState("");
    let [isNameError, setIsNameError] = useState(false);
    let [selectedVideoFrameRate, setSelectedVideoFrameRate] = useState<NumberOrNull>(null);
    let [selectedVideoWidth, setSelectedVideoWidth] = useState<NumberOrNull>(null);
    let [videoHeight, setVideoHeight] = useState<NumberOrNull>(null);
    let [selectedVideoCodec, setSelectedVideoCodec] = useState<StringOrNull>(null);
    let [selectedVideoBitrateKB, setSelectedVideoBitrateKB] = useState<NumberOrNull>(null);
    let [selectedAudioCodec, setSelectedAudioCodec] = useState<StringOrNull>(null);
    let [selectedAudioBitrateKB, setSelectedAudioBitrateKB] = useState<NumberOrNull>(null);
    let [selectedAudioChannels, setSelectedAudioChannels] = useState<NumberOrNull>(null);
    let [selectedAudioSampleRate, setSelectedAudioSampleRate] = useState<NumberOrNull>(null);
    let [isDynamicsRangeControlEnable, setIsDynamicsRangeControlEnable] = useState(false);
    let [selectedDynamicsRangeControlAmount, setSelectedDynamicsRangeControlAmount] = useState<StringOrNull>(null);

    let [isFilterDynamicEqEnable, setIsFilterDynamicEqEnable] = useState(false);
    let [isFilterHighPassEnable, setIsFilterHighPassEnable] = useState(false);
    let [filterHighPassFrequency, setFilterHighPassFrequency] = useState<string | number | null>(50);
    let [isFilterHighPassFrequencyError, setIsFilterHighPassFrequencyError] = useState(false);
    let [isFilterHumEnable, setIsFilterHumEnable] = useState(false);

    let [isLoudnessEnabled, setIsLoudnessEnabled] = useState(false);
    let [loudness, setLoudness] = useState<string | number | null>(null);
    let [isLoudnessError, setIsLoudnessError] = useState(false);
    let [truePeak, setTruePeak] = useState<string | number |null>(null);
    let [isTruePeakError, setIsTruePeakError] = useState(false);

    let [isMusicReductionEnable, setIsMusicReductionEnable] = useState(false);
    let [isNoiseReductionEnable , setIsNoiseReductionEnable] = useState(false);
    let [selectedNoiseReductionAmount, setSelectedNoiseReductionAmount] = useState<StringOrNull>(null);

    let [isSpeechClickReductionEnable, setIsSpeechClickReductionEnable] = useState(false);
    let [selectedSpeechClickReductionAmount, setSelectedSpeechClickReductionAmount] = useState<StringOrNull>(null);
    let [isSpeechIsolationEnable, setIsSpeechIsolationEnable] = useState(false);
    let [speechIsolationAmount, setSpeechIsolationAmount] = useState<string | number | null>(0);
    let [isSpeechIsolationAmountError, setIspeechIsolationAmountError] = useState(false);
    let [isSpeechPlosiveReductionEnable, setIsSpeechPlosiveReductionEnable] = useState(false);
    let [selectedPlosiveReductionAmount, setSelectedPlosiveReductionAmount] = useState<StringOrNull>(null);
    let [isSpeechSibilanceReductionEnable, setIsSpeechSibilanceReductionEnable] = useState(false);
    let [selectedSibilanceReductionAmount, setSelectedSibilanceReductionAmount] = useState<StringOrNull>(null);

    let [modalAction, setModalAction] = useState<ModalAction>("nothing");
    let [profileIdForAction, setProfileIdForAction] = useState("");
    let [isShowDeleteProfileModal, setIsShowDeleteProfileModal] = useState(false);

    let [isShowModal, setIsShowModal] = useState(false);

    useEffect(()=>{
        async function fetchProfiles(){
            setIsLoading(true);
            await Promise.all([updateTranscodingProfilesList()]);
            setIsLoading(false);
        }

        fetchProfiles()
    },[])

    const updateTranscodingProfilesList = async () => {
        let response = await getTranscodingProfiles();
        if( response.type === "succes") {
            setProfiles(response.data.items);
        }
    }

    const showModal = (action:ModalAction, profile?:MediaTranscodingProfile) => {
        setModalAction(action);
        setIsShowModal(true);
        if(profile){
            setProfileIdForAction(profile.id)
            setName(profile.name);
            setSelectedVideoFrameRate(profile.videoFrameRate);
            setSelectedVideoCodec(profile.videoCodec);
            setSelectedVideoBitrateKB(profile.videoBitrateKb);
            setSelectedVideoWidth(profile.videoWidth);
            setVideoHeight(profile.videoHeight);
            setSelectedAudioCodec(profile.audioCodec);
            setSelectedAudioBitrateKB(profile.audioBitrateKb);
            setSelectedAudioChannels(profile.audioChannels);
            setSelectedAudioSampleRate(profile.audioSampleRate);
            setIsDynamicsRangeControlEnable(profile.dynamicsRangeControlEnable);
            setSelectedDynamicsRangeControlAmount(profile.dynamicsRangeControlAmount);
            setIsFilterDynamicEqEnable(profile.filterDynamicEqEnable);
            setIsFilterHighPassEnable(profile.filterHighPassEnable);
            setFilterHighPassFrequency(profile.filterHighPassFrequency);
            setIsFilterHumEnable(profile.filterHumEnable);
            setIsLoudnessEnabled(profile.loudnessEnable)
            setLoudness(profile.loudnessTargetLevel);
            setTruePeak(profile.loudnessPeakLimit);
            setIsMusicReductionEnable(profile.musicReductionEnable);
            setIsNoiseReductionEnable(profile.noiseReductionEnable);
            setSelectedNoiseReductionAmount(profile.noiseReductionAmount);
            setIsSpeechClickReductionEnable(profile.speechClickReductionEnable);
            setSelectedSpeechClickReductionAmount(profile.speechClickReductionAmount);
            setIsSpeechIsolationEnable(profile.speechIsolationEnable);
            setSpeechIsolationAmount(profile.speechIsolationAmount);
            setIsSpeechPlosiveReductionEnable(profile.speechPlosiveReductionEnable);
            setSelectedPlosiveReductionAmount(profile.speechPlosiveReductionAmount);
            setIsSpeechSibilanceReductionEnable(profile.speechSibilanceReductionEnable);
            setSelectedSibilanceReductionAmount(profile.speechSibilanceReductionAmount);
        }
    }

    const hideModal = () => {
        setModalAction("nothing");
        setIsShowModal(false);
        setProfileIdForAction("");
        setName("");
        setIsNameError(false);
        setSelectedVideoFrameRate(null);
        setSelectedVideoCodec(null);
        setSelectedVideoBitrateKB(null);
        setSelectedVideoWidth(null);
        setVideoHeight(null);
        setSelectedAudioCodec(null);
        setSelectedAudioBitrateKB(null);
        setSelectedAudioChannels(null);
        setSelectedAudioSampleRate(null);
        setIsDynamicsRangeControlEnable(false);
        setSelectedDynamicsRangeControlAmount(null);
        setIsFilterDynamicEqEnable(false);
        setIsFilterHighPassEnable(false);
        setFilterHighPassFrequency(50);
        setIsFilterHighPassFrequencyError(false);
        setIsFilterHumEnable(false);
        setIsLoudnessEnabled(false);
        setLoudness(0);
        setIsLoudnessError(false);
        setTruePeak(0);
        setIsTruePeakError(false);
        setIsMusicReductionEnable(false);
        setIsNoiseReductionEnable(false);
        setSelectedNoiseReductionAmount(null);
        setIsSpeechClickReductionEnable(false);
        setSelectedSpeechClickReductionAmount(null);
        setIsSpeechIsolationEnable(false);
        setSpeechIsolationAmount(0);
        setIspeechIsolationAmountError(false);
        setIsSpeechPlosiveReductionEnable(false);
        setSelectedPlosiveReductionAmount(null);
        setIsSpeechSibilanceReductionEnable(false);
        setSelectedSibilanceReductionAmount(null);
    }

    const showDeleteModal = (id:Guid) => {
        setIsShowDeleteProfileModal(true);
        setProfileIdForAction(id);
    }

    const hideDeleteModal = () => {
        setIsShowDeleteProfileModal(false);
        setProfileIdForAction("");
    }

    const createOrUpdateTranscodingProfile = async () => {
        let isValid = true;

        if(!name){
            setIsNameError(true);
            isValid = false;
        }

        if(loudness !== null) {
            if(+loudness < -45 || +loudness > -8){
                setIsLoudnessError(true);
                isValid = false;
            }
        }

        if(truePeak !== null) {
            if(+truePeak < -33 || +truePeak > 0.1){
                setIsTruePeakError(true);
                isValid = false;
            }
        }

        if(filterHighPassFrequency !== null){
            if( +filterHighPassFrequency < 50 || +filterHighPassFrequency > 120){
                setIsFilterHighPassFrequencyError(true);
                isValid = false;
            }
        }

        if(speechIsolationAmount !== null){
            if( +speechIsolationAmount < 0 || +speechIsolationAmount > 100){
                setIspeechIsolationAmountError(true);
                isValid = false;
            }
        }
        
        if(!isValid) return;

        let request:MediaTranscodingProfileRequest = {
            name: name,
            videoFrameRate: selectedVideoFrameRate ?? null,
            videoCodec: selectedVideoCodec,
            videoBitrateKb:selectedVideoBitrateKB,
            videoWidth: selectedVideoWidth,
            videoHeight: null,
            audioCodec: selectedAudioCodec,
            audioBitrateKb: selectedAudioBitrateKB,
            audioChannels: selectedAudioChannels,
            audioSampleRate: selectedAudioSampleRate,
            dynamicsRangeControlEnable: isDynamicsRangeControlEnable,
            dynamicsRangeControlAmount: selectedDynamicsRangeControlAmount,
            filterDynamicEqEnable: isFilterDynamicEqEnable,
            filterHighPassEnable: isFilterHighPassEnable,
            filterHighPassFrequency: filterHighPassFrequency !== null ? +filterHighPassFrequency : null,
            filterHumEnable: isFilterHumEnable,
            loudnessEnable: isLoudnessEnabled,
            loudnessTargetLevel: loudness !== null ? +loudness : null,
            loudnessPeakLimit: truePeak !==null ? +truePeak : null,
            musicReductionEnable: isMusicReductionEnable,
            noiseReductionEnable: isNoiseReductionEnable,
            noiseReductionAmount: selectedNoiseReductionAmount,
            speechClickReductionEnable: isSpeechClickReductionEnable,
            speechClickReductionAmount: selectedSpeechClickReductionAmount ,
            speechIsolationEnable: isSpeechIsolationEnable,
            speechIsolationAmount: speechIsolationAmount !== null ? +speechIsolationAmount : null,
            speechPlosiveReductionEnable: isSpeechPlosiveReductionEnable,
            speechPlosiveReductionAmount: selectedPlosiveReductionAmount,
            speechSibilanceReductionEnable: isSpeechSibilanceReductionEnable,
            speechSibilanceReductionAmount: selectedSibilanceReductionAmount,
        }

        setIsLoading(true)
        if( modalAction === "edit" ) {
            await updateTranscodingProfile(profileIdForAction,request)
        }

        if( modalAction === "create" ) {
            await createTranscodingProfile(request);
        }

        await updateTranscodingProfilesList();
        hideModal();
        setIsLoading(false);
    }

    const removeTranscodingProfile = async () => {
        setIsLoading(true);
        await deleteTranscodingProfile(profileIdForAction);
        await updateTranscodingProfilesList();
        hideDeleteModal();
        setIsLoading(false);
    }

    const videoHeightHandler = (newValue: string) => {
        if(newValue === "") setVideoHeight(null);
        else setVideoHeight(+newValue);
    }

    const loudnessHandler = (newValue: string) => {
        if(newValue === "") setLoudness(null);
        else setLoudness(+newValue);
        setIsLoudnessError(false);
    }

    const truePeakHandler = (newValue: string) => {
        if(newValue === "") setTruePeak(null)
        else setTruePeak(+newValue);
        setIsTruePeakError(false);
    }

    const highPassFrequencyHandler = (newValue: string) => {
        if(newValue === "") setFilterHighPassFrequency(null);
        else setFilterHighPassFrequency(+newValue);
        setIsFilterHighPassFrequencyError(false);
    }

    const speechIsolationHandler = (newValue: string) => {
        if(newValue === "") setSpeechIsolationAmount(null)
        else setSpeechIsolationAmount(+newValue);
        setIspeechIsolationAmountError(false);
    }

    const renderStatus = (status:boolean) =>{
        return status ? <span className="current-status online">Enabled</span> : <span className="current-status offline">Disabled</span>
    }

    const renderProfilesList = (profiles: MediaTranscodingProfile[]) => {
        return profiles.map( it => {
            return <tr key={it.id}>
                <td>{it.name}</td>
                <td>
                    <p>Codec: {it.videoCodec}</p>
                    <p>Bit Rate: {it.videoBitrateKb} Kb/sec</p>
                    <p>Frame Rate: {it.videoFrameRate} FPS</p>
                    <p>Width: {it.videoWidth}</p>
                    <p>Height: {it.videoHeight}</p>
                </td>
                <td>
                    <p>Codec: {it.audioCodec}</p>
                    <p>Bit Rate: {it.audioBitrateKb} Kb/sec</p>
                    <p>Audio Channels: {it.audioChannels}</p>
                    <p>Audio Sample Rate: {it.audioSampleRate} Hz</p>
                </td>
                <td>
                    <p>Enabled: {renderStatus(it.dynamicsRangeControlEnable)}</p>
                    <p>Amount: {it.dynamicsRangeControlAmount}</p>
                </td>
                <td>
                    <p>DynamicEq: {renderStatus(it.filterDynamicEqEnable)}</p>
                    <p>HighPass: {renderStatus(it.filterHighPassEnable)}</p>
                    <p>HighPassFrequency: {it.filterHighPassFrequency} Hz</p>
                    <p>Hum: {renderStatus(it.filterHumEnable)}</p>
                </td>
                <td>
                    <p>Loudness: {renderStatus(it.loudnessEnable)}</p>
                    <p>Target Level: {it.loudnessTargetLevel} dB</p>
                    <p>Peak Limit: {it.loudnessPeakLimit} dB</p>
                </td>
                <td>
                    <p>Music Reduction: {renderStatus(it.musicReductionEnable)}</p>
                    <p>Noise Reduction: {renderStatus(it.noiseReductionEnable)}</p>
                    <p>Noise Reduction Amount: {it.noiseReductionAmount}</p>
                </td>
                <td>
                    <p>Click Reduction: {renderStatus(it.speechClickReductionEnable)}</p>
                    <p>Amount: {it.speechClickReductionAmount}</p>

                    <p>Isolation: {renderStatus(it.speechIsolationEnable)}</p>
                    <p>Amount {it.speechIsolationAmount}</p>

                    <p>Plosive Reduction {renderStatus(it.speechPlosiveReductionEnable)}</p>
                    <p>Amount {it.speechPlosiveReductionAmount}</p>

                    <p>Sibilance Reduction {renderStatus(it.speechSibilanceReductionEnable)}</p>
                    <p>Amount {it.speechSibilanceReductionAmount}</p>
                </td>
                <td>
                    <IconButton tooltipText="Edit" type="edit" onClick={() => {showModal("edit", it)}} />
                    <IconButton tooltipText="Delete" type="delete" onClick={() => {showDeleteModal(it.id)}} />
                </td>
            </tr>
        })
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-20 w-100">
                <h2>Media Transcoding Profiles</h2>
                <Button color="green"  label="Add Media Transcoding Profile" onClick={() => {showModal("create")}} />
            </div>

            {profiles.length ? <table className="table transcode-table">
                <thead>
                    <tr>
                        <td>Name</td>
                        <td>Video</td>
                        <td>Audio</td>
                        <td>Dynamic Range Control</td>
                        <td>Filter</td>
                        <td>Loudness</td>
                        <td>Noise / Music</td>
                        <td>Speech</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {renderProfilesList(profiles)}
                </tbody>
            </table> : <p>Element list is empty</p>}

            <CenterModal
                title={modalAction === "edit" ? "Edit Media Transcoding Profile" : "Add Media Transcoding Profile"} 
                show={isShowModal} 
                onRequestClose={hideModal}
            >
                <FormRowWithColumns>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter Name"
                            id = "profile_name"
                            isError = {isNameError}
                            title = "Name"
                            onChangeValue = {(v) => {setName(v); setIsNameError(false)}}
                            value = {name}
                        />
                    </FormRow>
                    <FormRow></FormRow>
                </FormRowWithColumns>
                <FormRowWithColumns>
                    <FormRow>
                        <ReactSelect<NumberOrNull>
                            title="Video Frame Rate FPS"
                            options={videoFrameRateOptions}
                            selectedValue={selectedVideoFrameRate}
                            onChange={setSelectedVideoFrameRate}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<NumberOrNull>
                            title="Video Width px"
                            options={videoWidthOptions}
                            selectedValue={selectedVideoWidth}
                            onChange={setSelectedVideoWidth}
                        />
                    </FormRow>
                    {/* <FormRow>
                        <FormInputNumber
                            id="videoheight"
                            title="Video Height"
                            isError={false}
                            errorMessage=""
                            value={videoHeight === null ? "" : videoHeight}
                            onChange={()=>{}}
                            onChangeValue={videoHeightHandler}
                        />
                    </FormRow> */}
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Video Codec"
                            options={videoCodecOptions}
                            selectedValue={selectedVideoCodec}
                            onChange={setSelectedVideoCodec}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<NumberOrNull>
                            title="Video Bitrate KB"
                            options={videoBitrateOptions}
                            selectedValue={selectedVideoBitrateKB}
                            onChange={setSelectedVideoBitrateKB}
                        />
                    </FormRow>
                </FormRowWithColumns>

                <FormRowWithColumns>
                    <FormRow>
                        <ReactSelect<NumberOrNull>
                            title="Audio Channels"
                            options={audioChannelsOptions}
                            selectedValue={selectedAudioChannels}
                            onChange={setSelectedAudioChannels}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<NumberOrNull>
                            title="Audio Sample Rate Hz"
                            options={audioSmapleOptions}
                            selectedValue={selectedAudioSampleRate}
                            onChange={setSelectedAudioSampleRate}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Audio Codec"
                            options={audioCodecOptions}
                            selectedValue={selectedAudioCodec}
                            onChange={setSelectedAudioCodec}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<NumberOrNull>
                            title="Audio Bitrate KB"
                            options={audioBitrateOptions}
                            selectedValue={selectedAudioBitrateKB}
                            onChange={setSelectedAudioBitrateKB}
                        />
                    </FormRow>
                </FormRowWithColumns>

                <FormRowWithColumns>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="loudness_enabled" checked={isLoudnessEnabled} onChange={setIsLoudnessEnabled} />
                            <span className="status-block">
                                {isLoudnessEnabled ? <span className="current-status online">&nbsp;Loudness Enabled </span> 
                                : <span className="current-status offline">&nbsp;Loudness Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <FormInputNumber
                            id="loudness"
                            title="Loudness Target Level dB"
                            isError={isLoudnessError}
                            errorMessage="Select correct loudness in range -45 : -8"
                            min={-45}
                            max={-8}
                            step={0.1}
                            value={loudness !== null ? loudness : ""}
                            onChange={()=>{}}
                            onChangeValue={loudnessHandler}
                        />
                    </FormRow>

                    <FormRow>
                        <FormInputNumber
                            id="true-peak"
                            title="Loudness True Peak dB"
                            isError={isTruePeakError}
                            errorMessage="Select correct true peak in range -3 : 0.1"
                            min={-33}
                            max={0.1}
                            step={0.1}
                            value={truePeak !== null ? truePeak : ""}
                            onChange={()=>{}}
                            onChangeValue={truePeakHandler}
                        />
                    </FormRow>

                    <FormRow></FormRow>
                </FormRowWithColumns>

                <FormRowWithColumns>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="click_reduction" checked={isSpeechClickReductionEnable} onChange={setIsSpeechClickReductionEnable} />
                            <span className="status-block">
                                {isSpeechClickReductionEnable ? <span className="current-status online">&nbsp;Speech Click Reduction Enabled</span> 
                                : <span className="current-status offline">&nbsp;Speech Click Reduction Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="speech_isolation" checked={isSpeechIsolationEnable} onChange={setIsSpeechIsolationEnable} />
                            <span className="status-block">
                                {isSpeechIsolationEnable ? <span className="current-status online">&nbsp;Speech Isolation Enabled</span> 
                                : <span className="current-status offline">&nbsp;Speech Isolation Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="plosive_reduction" checked={isSpeechPlosiveReductionEnable} onChange={setIsSpeechPlosiveReductionEnable} />
                            <span className="status-block">
                                {isSpeechPlosiveReductionEnable ? <span className="current-status online">&nbsp;Speech Plosive Reduction Enabled</span> 
                                : <span className="current-status offline">&nbsp;Speech Plosive Reduction Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="sibilance_reduction" checked={isSpeechSibilanceReductionEnable} onChange={setIsSpeechSibilanceReductionEnable} />
                            <span className="status-block">
                                {isSpeechSibilanceReductionEnable ? <span className="current-status online">&nbsp;Speech Sibilance Reduction Enabled</span> 
                                : <span className="current-status offline">&nbsp;Speech Sibilance Reduction Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    
                </FormRowWithColumns>

                <FormRowWithColumns>
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Speech Click Reduction Amount"
                            options={levelOptions}
                            selectedValue={selectedSpeechClickReductionAmount}
                            onChange={setSelectedSpeechClickReductionAmount}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber
                            id="speech_isolation_amount"
                            title="Speech Isolation Amount"
                            isError={isSpeechIsolationAmountError}
                            errorMessage="Select correct speech isolation in range 0 : 100"
                            min={0}
                            max={100}
                            step={1}
                            value={speechIsolationAmount !== null ? +speechIsolationAmount : ""}
                            onChange={()=>{}}
                            onChangeValue={speechIsolationHandler}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Speech Plosive Reduction Amount"
                            options={levelOptions}
                            selectedValue={selectedPlosiveReductionAmount}
                            onChange={setSelectedPlosiveReductionAmount}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Speech Sibilance Reduction Amount"
                            options={levelOptions}
                            selectedValue={selectedSibilanceReductionAmount}
                            onChange={setSelectedSibilanceReductionAmount}
                        />
                    </FormRow>
                </FormRowWithColumns>

                <FormRowWithColumns>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="noise_reduction" checked={isNoiseReductionEnable} onChange={setIsNoiseReductionEnable} />
                            <span className="status-block">
                                {isNoiseReductionEnable ? <span className="current-status online">&nbsp; Noise Reduction Enabled</span>
                                 : <span className="current-status offline">&nbsp;Noise Reduction Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="high-pass" checked={isFilterHighPassEnable} onChange={setIsFilterHighPassEnable} />
                            <span className="status-block">
                                {isFilterHighPassEnable ? <span className="current-status online">&nbsp;Dynamic High Pass Enabled</span>
                                 : <span className="current-status offline">&nbsp;Dynamic High Pass Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="dynamic-control-range" checked={isDynamicsRangeControlEnable} onChange={setIsDynamicsRangeControlEnable} />
                            <span className="status-block">
                                {isDynamicsRangeControlEnable ? <span className="current-status online">&nbsp;Dynamics Range Control Enabled</span> 
                                : <span className="current-status offline">&nbsp;Dynamics Range Control Disabled</span>}
                            </span>
                        </div>
                    </FormRow>
                    <FormRow>
                        <div className="" style={{position:"absolute"}}>
                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="eq" checked={isFilterDynamicEqEnable} onChange={setIsFilterDynamicEqEnable} />
                            <span className="status-block">
                                {isFilterDynamicEqEnable ? <span className="current-status online">&nbsp;Dynamic Eq Enabled</span> 
                                : <span className="current-status offline">&nbsp;Dynamic Eq Disabled</span>}
                            </span>
                        </div>

                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="use-nested" checked={isFilterHumEnable} onChange={setIsFilterHumEnable} />
                            <span className="status-block">
                                {isFilterHumEnable ? <span className="current-status online">&nbsp;Dynamic HUM Enabled</span> 
                                : <span className="current-status offline">&nbsp;Dynamic HUM Disabled</span>}
                            </span>
                        </div>

                        <div className="d-flex align-items-center pt-20">
                            <FormCheckbox id="music_reduction" checked={isMusicReductionEnable} onChange={setIsMusicReductionEnable} />
                            <span className="status-block">
                                {isMusicReductionEnable ? <span className="current-status online">&nbsp;Music Reduction Enabled</span> 
                                : <span className="current-status offline">&nbsp;Music Reduction Disabled</span>}
                            </span>
                        </div>
                        </div>
                    </FormRow>
                </FormRowWithColumns>
                
                <FormRowWithColumns>
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Noise Reduction Amount"
                            options={levelOptions}
                            selectedValue={selectedNoiseReductionAmount}
                            onChange={setSelectedNoiseReductionAmount}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber
                            id="filterHighPassFrequency"
                            title="High Pass Frequency Hz"
                            isError={isFilterHighPassFrequencyError}
                            errorMessage="Select correct frequency in range 50 : 120"
                            min={50}
                            max={120}
                            step={1}
                            value={filterHighPassFrequency !== null ? +filterHighPassFrequency : ""}
                            onChange={()=>{}}
                            onChangeValue={highPassFrequencyHandler}
                        />
                    </FormRow>
                    <FormRow>
                        <ReactSelect<StringOrNull>
                            title="Dynamic Range Control Amount"
                            options={levelOptions}
                            selectedValue={selectedDynamicsRangeControlAmount}
                            onChange={setSelectedDynamicsRangeControlAmount}
                        />
                    </FormRow>
                    <FormRow>

                    </FormRow>
                </FormRowWithColumns>

                

                <div className="modal-btn-group">
                    <Button color="green" label="Save" onClick={createOrUpdateTranscodingProfile}/>
                    <Button color="gray" label="Cancel" onClick={hideModal}/>
                </div>
            </CenterModal>  

            <SmallModal show={isShowDeleteProfileModal} onRequestClose={hideDeleteModal}> 
                <p>That you want to delete Profile?</p>
                <div className="modal-btn-group">
                    <Button color="gray" label="Cancel" onClick={hideDeleteModal}/>
                    <Button color="green" label="Yes" onClick={removeTranscodingProfile}/>
                </div>
            </SmallModal>

            <GlobalSpinner isShow={isLoading} />
        </>
    )
}

export default MediaTranscoding